import { api } from './api';

const getInsight = async () => {
  try {
    const { data } = await api.get(`/backoffice-insight/audience`);
    return data;
  } catch (err) {
    console.error(err);
    return [];
  }
};
const getInsightByUser = async email => {
  try {
    const { data } = await api.get(`/backoffice-insight/audience/${email}`);
    return data;
  } catch (err) {
    console.error(err);
    return [];
  }
};

const getSegmentFilesName = async segmentUploadTaskId => {
  try {
    const { data } = await api.get(
      `/v2/insight/insight/listProfileFiles/${segmentUploadTaskId}`
    );
    return data;
  } catch (err) {
    console.error(err);
    return [];
  }
};

const getRegion = async () => {
  try {
    const { data } = await api.get(`/backoffice-insight/category/region`);
    return data;
  } catch (e) {
    return null;
  }
};

const getDepartment = async () => {
  try {
    const { data } = await api.get(`/backoffice-insight/category/department`);
    return data;
  } catch (e) {
    return null;
  }
};

const getInternationalRegion = async (countryCode = 'FR') => {
  try {
    const { data } = await api.get(
      `/internationalLocations/regions/${countryCode}`
    );
    return data;
  } catch (e) {
    return null;
  }
};

const getInternationalDepartment = async (countryCode = 'FR') => {
  try {
    const { data } = await api.get(
      `/internationalLocations/departments/${countryCode}`
    );
    return data;
  } catch (e) {
    return null;
  }
};

const getAvailableGeoLevels = async () => {
  try {
    const { data } = await api.get(
      `/internationalLocations/availableGeoLevels`
    );
    return data;
  } catch (e) {
    return null;
  }
};

const getMatchedDepartments = async ({ filter, countryCode }) => {
  try {
    const { data } = await api.post(`/category/matchedDepartments`, {
      filter,
      countryCode: countryCode?.toUpperCase()
    });
    return data;
  } catch (err) {
    console.error(err);
    return [];
  }
};

const getInsightShopByIds = async ({ ids, light = false }) => {
  try {
    const { data } = await api.post(`/insightShops/ids`, {
      ids,
      light
    });
    return data;
  } catch (err) {
    console.error(err);
    return [];
  }
};

const getGeoZone = async payload => {
  try {
    const { data } = await api.post(`/v2/insight/searchfields/zones`, payload);
    return data;
  } catch (err) {
    console.error(err);
    return null;
  }
};
const getPostalCode = async payload => {
  try {
    const { data } = await api.post(
      `/v2/insight/searchfields/postalcode`,
      payload
    );
    return data;
  } catch (err) {
    console.error(err);
    return null;
  }
};
const getCommune = async payload => {
  try {
    const { data } = await api.post(
      `/v2/insight/searchfields/commune`,
      payload
    );
    return data;
  } catch (err) {
    console.error(err);
    return null;
  }
};
const getIrisCode = async payload => {
  try {
    const { data } = await api.post(`/v2/insight/searchfields/iris`, payload);
    return data;
  } catch (err) {
    console.error(err);
    return null;
  }
};
const getNbProfils = async payload => {
  try {
    const { data } = await api.post(`/v2/insight/result/profils`, payload);
    return data;
  } catch (err) {
    console.error(err);
    return [];
  }
};
const getGeo = async payload => {
  try {
    const { data } = await api.post(`/v2/insight/searchfields/geo`, payload);
    return data;
  } catch (err) {
    console.error(err);
    return null;
  }
};

export default {
  getInsight,
  getInsightByUser,
  getSegmentFilesName,
  getRegion,
  getDepartment,
  getInsightShopByIds,
  getInternationalRegion,
  getInternationalDepartment,
  getAvailableGeoLevels,
  getMatchedDepartments,
  getGeoZone,
  getPostalCode,
  getCommune,
  getIrisCode,
  getNbProfils,
  getGeo
};
